import isEmpty from 'lodash/isEmpty';

import 'fomantic-ui-less/definitions/modules/transition.less';
import 'fomantic-ui-less/definitions/modules/dropdown.less';

import 'fomantic-ui-less/definitions/behaviors/api';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';
import {parseJSON, stringifyJSON} from './json';
import {encode} from 'html-entities';
import {urlData} from './urlData';
import jsonata from 'jsonata';
import {filterFields} from './formFields';
import {
  toWorkflowDefinitionVersionResults,
  workflowDefinitionVersionsEndpoint,
} from './workflowDefinitionVersions';
import {
  pageVersionsEndpoint,
  toPageVersionResults,
} from './pageVersions';

const isSelectedDropdownValue = item => item.selected === true || ['true', '1'].includes(item.selected);

const hasDropdownValue = value => value !== undefined && value !== null && value !== '';

const dropdownControl = el => el.matches?.('input, select') ? el : el.querySelector('input, select');

export const pageVersionsSelectDropdown = ({
                                             element,
                                             pageId,
                                             value,
                                             onChange = undefined,
                                             clearable = true,
                                             searchable = true,
                                           }) => {
  const dropdown = $(element).dropdown({
    transition: 'scale',
    duration: 0,
    showNoResults: false,
    clearable,
    searchable,
    apiSettings: {
      url: pageVersionsEndpoint(pageId),
      cache: false,
      rawResponse: true,
      onResponse: toPageVersionResults,
    },
    onChange,
    filterRemoteData: true,
    saveRemoteData: false,
  });

  if (!isEmpty(value)) {
    dropdown.dropdown('queryRemote', '', function() {
      dropdown.dropdown('set selected', value);
    });
  }

  return dropdown;
};

export const workflowDefinitionVersionsSelectDropdown = ({
                                                           element,
                                                           workflowDefinitionId,
                                                           value,
                                                           onChange = undefined,
                                                           clearable = true,
                                                           searchable = true,
                                                         }) => {
  const dropdown = $(element).dropdown({
    transition: 'scale',
    duration: 0,
    showNoResults: false,
    clearable,
    searchable,
    apiSettings: {
      url: workflowDefinitionVersionsEndpoint(workflowDefinitionId),
      cache: false,
      rawResponse: true,
      onResponse: toWorkflowDefinitionVersionResults,
    },
    onChange,
    filterRemoteData: true,
    saveRemoteData: false,
  });

  if (!isEmpty(value)) {
    dropdown.dropdown('queryRemote', '', function() {
      dropdown.dropdown('set selected', value);
    });
  }

  return dropdown;
};

export const usersSearchDropdown = ({
                                      element,
                                      value,
                                      onChange = undefined,
                                      clearable = false,
                                      searchable = true,
                                    }) => {
  const dropdown = $(element).dropdown({
    transition: 'scale',
    duration: 0,
    clearable,
    searchable,
    showNoResults: false,
    apiSettings: {
      url: '/api/search/users?query={query}',
      onResponse: searchResponse => {
        const results = searchResponse.content.map(user => ({
          name: isEmpty(user.fullName) ? user.email : user.fullName,
          image: `/avatar/${user.id}`,
          imageClass: 'ui circular image icon icon-18',
          value: user.id,
        }));

        return {results};
      },
    },
    onChange
  });

  if (!isEmpty(value)) {
    dropdown.dropdown('queryRemote', value, function() {
      dropdown.dropdown('set selected', value);
    });
  }

  return dropdown;
};

export const setupDropdowns = element => {
  [
    ...(element.matches?.('.ui.dropdown') ? [element] : []),
    ...element.querySelectorAll('.ui.dropdown')
  ].forEach(el => {
    const settings = {
      preserveHTML: false,
      duration: 0,
      forceSelection: false
    };
    let latestRemoteResponseVersion = 0;

    if (el.id === 'page-header-dropdown') {
      settings.action = 'nothing';
      settings.selectOnKeydown = false;
    }

    if (el.classList.contains('addition') || el.classList.contains('additions')) {
      settings.allowAdditions = true;
      settings.showNoResults = false;
    }

    if (el.classList.contains('search')) {
      settings.fullTextSearch = true;
    }

    if (el.classList.contains('clearable')) {
      settings.clearable = true;
    }

    const control = dropdownControl(el);
    let selectedValues = [];
    const settingsAttribute = el.getAttribute('data-settings') ?? control?.getAttribute?.('data-settings');
    const dataSettings = parseJSON(settingsAttribute);
    if (dataSettings) {
      const {
        credentials,
        url,
        method,
        headers,
        data,
        resultSelectorJSONata,
      } = dataSettings?.api || {};

      if (!isEmpty(url)) {
        const isSimWorkflowApi = url.startsWith('/api/');

        settings.apiSettings = {
          cache: !isSimWorkflowApi,
          url: isSimWorkflowApi ? url : '/api/proxy',
          method: isSimWorkflowApi ? method : 'POST',
        };

        if (!isEmpty(resultSelectorJSONata)) {
          settings.apiSettings.responseAsync = function(requestSettings, complete) {
            const remoteResponseVersion = ++latestRemoteResponseVersion;
            const requestData = isSimWorkflowApi
              ? data
              : stringifyJSON({
                credentials,
                url: urlData(url, requestSettings),
                method,
                headers,
                body: data,
                input: filterFields($(el.closest('.ui.form'))?.form('get values'))
              });
            const requestHeaders = {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              ...(isSimWorkflowApi ? headers : {}),
            };

            $.ajax({
              url: requestSettings.url,
              method: requestSettings.method,
              data: requestData,
              dataType: 'json',
              headers: requestHeaders,
            }).done(response => {
              jsonata(resultSelectorJSONata).evaluate(response)
                  .then(items => {
                    if (remoteResponseVersion === latestRemoteResponseVersion) {
                      complete({
                        results: items.map(item => ({
                          ...item,
                          selected: isSelectedDropdownValue(item)
                        }))
                      });
                    }
                  })
                  .catch(() => {
                    if (remoteResponseVersion === latestRemoteResponseVersion) {
                      complete({results: []});
                    }
                  });
            }).fail(() => {
              if (remoteResponseVersion === latestRemoteResponseVersion) {
                complete(false);
              }
            });
          };
        } else {
          settings.apiSettings.beforeXHR = function(xhr, xhrSettings) {
            if (isSimWorkflowApi) {
              xhrSettings.data = data;

              if (!isEmpty(headers)) {
                Object.keys(headers).
                forEach(headerName => {
                  xhr.setRequestHeader(headerName,
                      headers[headerName]);
                });
              }
            } else {
              xhrSettings.data = stringifyJSON({
                credentials,
                url: urlData(url, this),
                method,
                headers,
                body: data,
                input: filterFields($(el.closest('.ui.form'))?.form('get values'))
              });
            }
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            return xhr;
          };
        }

        if (settings.fullTextSearch && !url?.includes('{query}')) {
          settings.filterRemoteData = true;
        }
      } else if (!isEmpty(dataSettings.values)) {
        settings.values = dataSettings.values.map(item => ({
          ...item,
          value: typeof item.value === 'string' ? encode(item.value) : item.value,
          selected: isSelectedDropdownValue(item)
        }));
        selectedValues = dataSettings.values.
          filter(item => isSelectedDropdownValue(item) && hasDropdownValue(item.value)).
          map(item => item.value);
      }
    }

    const readOnly = el.hasAttribute('readonly') || el.classList.contains('readonly');
    if (readOnly) {
      if (control) {
        control.disabled = true;
        control.setAttribute('disabled', '');
        if (control === el) {
          el.classList.add('disabled');
        }
      } else {
        el.classList.add('disabled');
        el.disabled = true;
        el.setAttribute?.('disabled', '');
      }
    }

    const dropdown = $(el).dropdown(settings);
    if (selectedValues.length > 0) {
      dropdown.dropdown('set selected', el.classList.contains('multiple') ? selectedValues : selectedValues[0]);
    }
  });
}
